export default __webpack_public_path__ + "static/media/warning.cb7c93f7.svg";